import { render, staticRenderFns } from "./TermsAndPolicy.vue?vue&type=template&id=bea288da"
import script from "./TermsAndPolicy.vue?vue&type=script&lang=js"
export * from "./TermsAndPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports